/**
 * flextoyz-catwalk.js
 * Vertaalt verticale scroll naar een horizontale transform op de kaarten-track.
 * Op mobiel valt het terug op native horizontaal swipen.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var sections = document.querySelectorAll('[data-ft-catwalk]');

  sections.forEach(function (section) {
    var track = section.querySelector('[data-ft-catwalk-track]');
    if (!track) return;

    function update() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        track.style.transform = 'none';
        return;
      }

      var rect      = section.getBoundingClientRect();
      var viewportH = window.innerHeight;

      // Animate as section traverses the viewport: 0 when entering from bottom, 1 when exiting at top.
      // Works without any extra section height beyond 100vh.
      var entered  = viewportH - rect.top;
      var total    = viewportH + rect.height;
      var progress = total > 0 ? entered / total : 0;
      progress = Math.max(0, Math.min(progress, 1));

      var maxScroll = track.scrollWidth - section.clientWidth + 48;
      track.style.transform = 'translateX(-' + (progress * maxScroll) + 'px)';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

/**
 * Voorkomt horizontale paginascroll op iOS Safari.
 * Horizontaal swipen BINNEN scroll-containers (catwalk, carrousel) blijft werken.
 */
(function preventPageHorizontalScroll() {
  var startX = 0;
  var startY = 0;

  document.addEventListener('touchstart', function (e) {
    startX = e.touches[0].pageX;
    startY = e.touches[0].pageY;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var dx = e.touches[0].pageX - startX;
    var dy = e.touches[0].pageY - startY;

    if (Math.abs(dx) <= Math.abs(dy)) return;

    var el = e.target;
    while (el && el !== document.documentElement) {
      var style = window.getComputedStyle(el);
      var overflowX = style.overflowX;
      if (overflowX === 'auto' || overflowX === 'scroll') {
        return;
      }
      el = el.parentElement;
    }

    e.preventDefault();
  }, { passive: false });
})();
